import { ArticleParagraph3, FormField, InputAdornment, InputSlider, NumberInput } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MortgageOffersFilters.css';
import { getInitialPaymentInPercents, getInitialPaymentStep } from './helpers';
import { MAX_LOAN_TERM, MIN_LOAN_TERM } from '../../../../constants/newbuildingMortgage';

interface IMortgageOffersFiltersProps {
  initialPayment: number;
  loanTerm: number;
  onInitialPaymentChange: (value: number) => void;
  onInitialPaymentMouseDown: () => void;
  onLoanTermChange: (value: number) => void;
  onLoanTermMouseDown: () => void;
  price: number;
}

export const MortgageOffersFilters: React.FC<IMortgageOffersFiltersProps> = ({
  initialPayment,
  loanTerm,
  onInitialPaymentChange,
  onInitialPaymentMouseDown,
  onLoanTermChange,
  onLoanTermMouseDown,
  price,
}) => {
  const downPaymentInPercents = getInitialPaymentInPercents(price, initialPayment);
  const downPaymentStep = getInitialPaymentStep(price);

  return (
    <div className={styles['container']}>
      <div className={styles['field']}>
        <FormField label="Стоимость недвижимости" withoutMargin>
          <NumberInput
            value={price}
            rightAdornment={<InputAdornment>₽</InputAdornment>}
            name="price"
            size="M"
            data-testid="PriceInput"
            disabled
            readOnly
          />
        </FormField>
      </div>
      <div className={styles['field']}>
        <FormField label="Первоначальный взнос" withoutMargin>
          <>
            <InputSlider
              onChange={onInitialPaymentChange}
              onMouseDown={onInitialPaymentMouseDown}
              value={initialPayment}
              max={price}
              min={0}
              step={downPaymentStep}
              rightAdornment={<InputAdornment>₽</InputAdornment>}
              name="initial-payment"
              data-testid="InitialPaymentInput"
            />
            <ArticleParagraph3 color="gray_icons_100">{downPaymentInPercents}</ArticleParagraph3>
          </>
        </FormField>
      </div>
      <div className={styles['field']}>
        <FormField label="Срок" withoutMargin>
          <InputSlider
            onChange={onLoanTermChange}
            onMouseDown={onLoanTermMouseDown}
            value={loanTerm}
            max={MAX_LOAN_TERM}
            min={MIN_LOAN_TERM}
            rightAdornment={<InputAdornment>лет</InputAdornment>}
            name="loan-term"
            data-testid="LoanTermInput"
          />
        </FormField>
      </div>
    </div>
  );
};
